import type { FeedsDataItem } from '../feeds_list_types';

function formatNumber(val: any): string {
    if (val === null || val === undefined || val === '') return '';
    if (typeof val === 'number') return val.toLocaleString();
    if (typeof val === 'string') {
        const num = Number(val.replace(/,/g, '').trim());
        return isNaN(num) ? val : num.toLocaleString();
    }
    return '';
}

export default function feedsListApiToVM(apiResult: any): FeedsDataItem[] {
    const items = Array.isArray(apiResult) ? apiResult : [];

    items.forEach(item => {
        item.RecordsDuplicate = formatNumber(item.RecordsDuplicate);
        item.RecordsError = formatNumber(item.RecordsError);
        item.RecordsProcessed = formatNumber(item.RecordsProcessed);
        item.RecordsReceived = formatNumber(item.RecordsReceived);
        item.RecordsRejected = formatNumber(item.RecordsRejected);

        item.CoveredEntity = Array.isArray(item.CoveredEntity)
            ? item.CoveredEntity.sort((a: string, b: string) => a.localeCompare(b))
            : [];
        item.Pharmacy = Array.isArray(item.Pharmacy)
            ? item.Pharmacy.sort((a: string, b: string) => a.localeCompare(b))
            : [];
    });

    return items;
}
